import axios, { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

export const usePost = <T>(url: string, axiosCfg: AxiosRequestConfig = {}, queryOptions: UseQueryOptions<UsePostResponse<T>, Error> = {}) => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<UsePostResponse<T>, Error>({
    queryKey: [url, ...queryKey],

    queryFn: async () => {
      const axiosRes = await axios.request<UsePostResponse<T>>({ url, method: 'POST', ...axiosCfg });
      return axiosRes.data;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

export type UsePostResponse<T> = {
  Data: T;
};
